<template>
  <BaseDialog
    v-model="showDialog"
    :title="title"
    :subtitle="subtitle"
    :dialogIcon="icon"
    :btnActionName="btnActionName"
    :btnCloseName="btnCloseName"
    :showContent="showContent"
    @action="$emit('action')"
    @close="$emit('close')"
  >
    <template v-slot>
      <div v-if="showContent">
        <slot name="transitionBtn"></slot>
        <slot name="contentElement"></slot>
      </div>
      <div v-html="text"></div>
    </template>
  </BaseDialog>
</template>

<script lang="ts">
import Vue from "vue";
import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    icon: {
      type: String,
    },
    text: {
      type: String,
    },
    btnActionName: {
      default: null,
    },
    btnCloseName: {
      required: false,
    },
    showContent: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },
  components: {
    BaseDialog,
  },
});
</script>
